// extracted by mini-css-extract-plugin
export var attachment = "_o8-a";
export var emailContainer = "_o8-4";
export var emailContentPaddedContainer = "_o8-b";
export var emailHeader = "_o8-6";
export var emailIframe = "_o8-3";
export var emailInfoIcon = "_o8-9";
export var emailShortenedSummary = "_o8-e";
export var infoDropdown = "_o8-0";
export var infoRowBoundedContent = "_o8-d";
export var internal = "_o8-5";
export var merchant = "_o8-8";
export var messageInputContainer = "_o8-h";
export var normal = "_o8-7";
export var replyCard = "_o8-f";
export var subtleButton = "_o8-1";
export var subtleButtonIconContainer = "_o8-2";
export var toggleViewRepliesButton = "_o8-c";
export var wrappingText = "_o8-g";